module.exports = __webpack_public_path__ + "media/images/lb/974-c38e613eae48094d57de8049c9812d09.svg";